import {Component} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {LOGIN_ROUTE} from "src/app/app-routing.module";
import {TranslocoService} from "@ngneat/transloco";
import {email, max_length_50, required} from "@utility";
import {AuthenticationService, ToastService} from "@services";
import {User, TOAST_STATE} from "@model";

@Component({
    selector: 'app-recover-lost-password',
    templateUrl: './recover-lost-password.component.html',
    styleUrls: ['./recover-lost-password.component.scss'],
    standalone: false
})
export class RecoverLostPasswordComponent {

  recoverLostPasswordComponentState: RecoverLostPasswordComponentState = RecoverLostPasswordComponentState.INITIAL;
  recoverLostPasswordComponentStateType = RecoverLostPasswordComponentState;
  inputForm = new FormGroup({
    email: new FormControl('', [
      required,
      email,
      max_length_50
    ]
    ),
  });

  constructor(private authService: AuthenticationService, private router: Router, private toastService: ToastService,
              private translocoService: TranslocoService) {
  }

  onSubmit(): void {
    if (!this.inputForm.valid) {
      for (const control in this.inputForm.controls) {
        this.inputForm.get(control)?.markAsTouched();
      }
      return;
    }
    var user: User = new User();
    user.email = <string | undefined> this.inputForm.value.email;
    this.authService.recoverAccount(user, () => {
      this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate('recover.lost.password.email.sent'));
      this.router.navigate([LOGIN_ROUTE]);
    }, () => {
      this.recoverLostPasswordComponentState = RecoverLostPasswordComponentState.ERROR;
    });
  }

  toLogin(): void {
    this.router.navigate([LOGIN_ROUTE]);
  }
}

enum RecoverLostPasswordComponentState {
  INITIAL,
  ERROR,
}
